import { render, staticRenderFns } from "./Profile.template.vue?vue&type=template&id=b0c0886a&scoped=true&"
var script = {}
import style0 from "./Profile.template.vue?vue&type=style&index=0&id=b0c0886a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c0886a",
  null
  
)

export default component.exports